<template>
  <div>
    <v-btn
      @click="dialog = true"
      class="white--text text-capitalize"
      color="#004643"
    >
      Update Nilai Aset
    </v-btn>

    <v-dialog v-model="dialog" width="80vw" @input="onDialogChange">
      <v-card class="pa-6 rounded-xl d-flex flex-column" style="gap: 20px">
        <!-- Nilai Perolehan aset -->
        <v-card class="d-flex flex-column rounded-xl">
          <!-- Header -->
          <div
            class="d-flex align-center text-h6 font-weight-bold px-4 justify-space-between"
            style="width: 100%; height: 50px; background-color: #abd1c6"
          >
            <div class="d-flex align-center">
              Nilai Perolehan Aset
              <div>
                <v-select
                  outlined
                  dense
                  :items="years"
                  v-model="year"
                  @change="getAssetPrice"
                  menu-props="auto"
                  content-class="scroll-to-current"
                  scrollToSelected
                  hide-details
                  :disabled="isEditable"
                  style="
                    width: 100px;
                    margin-left: 10px;
                    background-color: white;
                    height: 40px;
                  "
                ></v-select>
              </div>
            </div>
            <div
              class="text-right px-4 rounded-lg d-flex align-center justify-space-between"
              style="
                font-size: 16px;
                font-weight: 400;
                background-color: white;
                width: 500px;
              "
            >
              <div>Total Nilai Perolehan Aset</div>
              <div class="font-weight-bold">
                {{ formatRupiah(assetPrices[0]?.total?.total || 0) }}
              </div>
            </div>
          </div>

          <!-- Content -->
          <div class="d-flex justify-center align-center my-2 mx-2">
            <v-col v-for="(data, index) in labelsKey" :key="index">
              <div
                outlined
                class="d-flex align-center py-3 px-5 rounded-lg"
                :style="{
                  borderColor: '#abd1c6',
                  borderWidth: '1px',
                  borderStyle: 'solid',
                  height: '120px',
                }"
              >
                <div>
                  <h5 style="font-size: 14px; font-weight: 200">
                    {{ data.label }}
                  </h5>
                  <p
                    class="pt-1 pr-10 ma-0"
                    style="font-size: 20px; font-weight: 600"
                  >
                    {{
                      formatRupiah(assetPrices[0]?.["total"]?.[data.key] || 0)
                    }}
                  </p>
                </div>
              </div>
            </v-col>
          </div>
        </v-card>

        <!-- Update -->
        <v-card class="d-flex flex-column rounded-xl">
          <!-- Header -->
          <div
            class="d-flex align-center text-h6 font-weight-bold px-4 justify-space-between"
            style="width: 100%; height: 50px; background-color: #abd1c6"
          >
            Update Nilai Perolehan Aset
            <div class="d-flex" style="gap: 10px">
              <v-btn
                outlined
                color="#004643"
                @click="isEditable = true"
                style="text-transform: none; background-color: white"
                :disabled="isEditable"
              >
                Update
              </v-btn>
              <v-btn
                @click="submit()"
                class="white--text"
                color="#004643"
                style="text-transform: none"
                :disabled="!isEditable"
              >
                Save
              </v-btn>
            </div>
          </div>

          <!-- Content Update -->
          <!-- Row 1 -->
          <div
            class="d-flex justify-center align-center mt-2 mx-2"
            style="background-color: #e4efec"
          >
            <v-col cols="2"></v-col>
            <v-col class="text-center">Tanah</v-col>
            <v-col class="text-center">Peralatan Mesin</v-col>
            <v-col class="text-center">Gedung dan Bangunan</v-col>
            <v-col class="text-center">Jalan Irigasi dan Jaringan</v-col>
            <v-col class="text-center">Aset Tak Berwujud</v-col>
            <v-col class="text-center">Total</v-col>
          </div>
          <div
            class="d-flex justify-center align-center mt-2 mx-2"
            v-for="(item, index) in tableIndex.slice(0, 1)"
            :key="index"
          >
            <v-col cols="2">{{ item.label }}</v-col>
            <v-col
              class="text-center"
              v-for="(col, i) in tableColumns"
              :key="i"
            >
              <v-text-field
                outlined
                dense
                class="pa-0 centered-input"
                required
                :type="[1, 2, 3, 4].includes(i) ? 'text' : 'number'"
                :rules="rules"
                disabled
                hide-details
                :value="
                  [1, 2, 3, 4].includes(i)
                    ? '-'
                    : assetPrices[0]?.[item.key]?.[col] || 0
                "
              ></v-text-field>
            </v-col>
          </div>

          <!-- Row 2 -->
          <div
            class="d-flex align-center mt-2 mx-2 px-2 py-1"
            style="background-color: #e4efec"
          >
            Nilai Perolehan Konstruksi
          </div>
          <div
            class="d-flex justify-center align-center mt-2 mx-2"
            v-for="(item, index) in tableIndex.slice(1, 3)"
            :key="'row2-' + index"
          >
            <v-col cols="2">{{ item.label }}</v-col>
            <v-col
              class="text-center"
              v-for="(col, i) in tableColumns"
              :key="'row2-col-' + i + '-' + item.key"
            >
              <v-text-field
                v-if="
                  !(
                    [0].includes(i) ||
                    (item.key === 'peralatan_tol' && [3, 4].includes(i))
                  )
                "
                outlined
                dense
                class="pa-0 centered-input"
                required
                type="number"
                :rules="rules"
                :disabled="
                  !isEditable ||
                  [0, 5].includes(i) ||
                  (item.key === 'peralatan_tol' && [3, 4].includes(i))
                "
                hide-details
                v-model.number="editedData[item.key][col]"
              ></v-text-field>
              <v-text-field
                v-else
                outlined
                dense
                class="pa-0 centered-input"
                disabled
                hide-details
                value="-"
              ></v-text-field>
            </v-col>
          </div>

          <!-- Row 3 -->
          <div
            class="d-flex align-center mt-2 mx-2 px-2 py-1"
            style="background-color: #e4efec"
          >
            Nilai Perolehan Konstruksi
          </div>
          <div
            class="d-flex justify-center align-center mt-2 mx-2"
            v-for="(item, index) in tableIndex.slice(3, 9)"
            :key="'row3-' + index"
          >
            <v-col cols="2">{{ item.label }}</v-col>
            <v-col
              class="text-center"
              v-for="(col, i) in tableColumns"
              :key="'row3-col-' + i + '-' + item.key"
            >
              <v-text-field
                v-if="!([0].includes(i) && item.key !== 'total')"
                outlined
                dense
                class="pa-0 centered-input"
                required
                type="number"
                :rules="rules"
                :disabled="
                  !isEditable ||
                  ([0, 5].includes(i) && item.key !== 'total') ||
                  item.key === 'total'
                "
                hide-details
                v-model.number="editedData[item.key][col]"
              ></v-text-field>
              <v-text-field
                v-else
                outlined
                dense
                class="pa-0 centered-input"
                disabled
                hide-details
                value="-"
              ></v-text-field>
            </v-col>
          </div>
        </v-card>

        <v-overlay :value="isUploading" absolute>
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      top
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false" color="white"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { formatRupiah } from "@/plugins/helpers";

export default {
  data() {
    return {
      labelsKey: [
        {
          label: "Tanah Rumpun Jalan dan Transportasi",
          key: "land_price",
        },
        {
          label: "Peralatan dan Mesin Rumpun Jalan dan Transportasi",
          key: "machine_price",
        },
        {
          label: "Gedung dan Bangunan Rumpun Jalan dan Transportasi",
          key: "building_price",
        },
        {
          label: "Jalan, Irigasi, dan Jaringan Rumpun Jalan dan Transportasi",
          key: "infrastructure_price",
        },
        {
          label: "Aset Tak Berwujud Rumpun Jalan dan Transportasi",
          key: "intangible_asset_price",
        },
      ],
      dialog: false,
      isUploading: false,
      snackbar: {
        show: false,
        text: "",
        color: "",
      },
      years: Array.from({ length: 111 }, (_, i) => 1990 + i),
      year: new Date().getFullYear(),
      assetFields: [
        { label: "Tanah", model: null },
        { label: "Mesin dan Peralatan", model: null },
        { label: "Gedung dan Bangunan", model: null },
        { label: "Jalan Irigasi dan Jaringan", model: null },
        { label: "Aset Tak Berwujud", model: null },
      ],
      rules: [
        (value) => !!value || "Isi tidak boleh kosong",
        (value) => !isNaN(parseFloat(value)) || "Harus berupa angka",
      ],
      assetPrices: [],
      editedData: {
        konstruksi: {
          building_price: 0,
          infrastructure_price: 0,
          machine_price: 0,
          intangible_asset_price: 0,
          total: 0,
        },
        peralatan_tol: {
          building_price: 0,
          infrastructure_price: 0,
          machine_price: 0,
          intangible_asset_price: 0,
          total: 0,
        },
        supervisi: {
          building_price: 0,
          infrastructure_price: 0,
          machine_price: 0,
          intangible_asset_price: 0,
          total: 0,
        },
        desain_pendampingan: {
          building_price: 0,
          infrastructure_price: 0,
          machine_price: 0,
          intangible_asset_price: 0,
          total: 0,
        },
        overhead: {
          building_price: 0,
          infrastructure_price: 0,
          machine_price: 0,
          intangible_asset_price: 0,
          total: 0,
        },
        financial_cost: {
          building_price: 0,
          infrastructure_price: 0,
          machine_price: 0,
          intangible_asset_price: 0,
          total: 0,
        },
        idc: {
          building_price: 0,
          infrastructure_price: 0,
          machine_price: 0,
          intangible_asset_price: 0,
          total: 0,
        },
        total: {
          building_price: 0,
          infrastructure_price: 0,
          machine_price: 0,
          intangible_asset_price: 0,
          land_price: 0,
          total: 0,
        },
        land_price: {
          land_price: 0,
          total: 0,
        },
      },
      valid: false,
      tableColumns: [
        "land_price",
        "machine_price",
        "building_price",
        "infrastructure_price",
        "intangible_asset_price",
        "total",
      ],
      tableIndex: [
        { key: "land_price", label: "Biaya Pengadaan Tanah" },
        { key: "konstruksi", label: "Konstruksi" },
        { key: "peralatan_tol", label: "Peralatan Tol" },
        { key: "supervisi", label: "Supervisi" },
        { key: "desain_pendampingan", label: "Desain dan Pendampingan" },
        { key: "overhead", label: "Overhead" },
        { key: "financial_cost", label: "Financial Cost" },
        { key: "idc", label: "IDC" },
        { key: "total", label: "Total" },
      ],
      isEditable: false,
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    payload() {
      // Prepare payload for submit
      const data = JSON.parse(JSON.stringify(this.editedData));
      this.cleanEditedData(data);
      return {
        year: this.year,
        konstruksi: data.konstruksi,
        peralatan_tol: data.peralatan_tol,
        supervisi: data.supervisi,
        desain_pendampingan: data.desain_pendampingan,
        overhead: data.overhead,
        financial_cost: data.financial_cost,
        idc: data.idc,
      };
    },
  },
  methods: {
    resetFields() {
      this.assetFields.forEach((field) => (field.model = null));
    },
    showNotification(text, color) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    formatRupiah,
    onDialogChange(val) {
      if (val) this.syncEditedData();
    },
    syncEditedData() {
      if (this.assetPrices && this.assetPrices.length > 0) {
        const data = this.assetPrices[0];
        this.editedData = {
          konstruksi: JSON.parse(
            JSON.stringify(data.konstruksi || this.editedData.konstruksi)
          ),
          peralatan_tol: JSON.parse(
            JSON.stringify(data.peralatan_tol || this.editedData.peralatan_tol)
          ),
          supervisi: JSON.parse(
            JSON.stringify(data.supervisi || this.editedData.supervisi)
          ),
          desain_pendampingan: JSON.parse(
            JSON.stringify(
              data.desain_pendampingan || this.editedData.desain_pendampingan
            )
          ),
          overhead: JSON.parse(
            JSON.stringify(data.overhead || this.editedData.overhead)
          ),
          financial_cost: JSON.parse(
            JSON.stringify(
              data.financial_cost || this.editedData.financial_cost
            )
          ),
          idc: JSON.parse(JSON.stringify(data.idc || this.editedData.idc)),
          total: JSON.parse(
            JSON.stringify(data.total || this.editedData.total)
          ),
          land_price: JSON.parse(
            JSON.stringify(data.land_price || this.editedData.land_price)
          ),
        };
      }
    },
    async init() {
      const response = await this.$axios.get("/asset-prices", {
        params: { year: this.year },
      });
      this.assetPrices = response.data.data.asset_prices;
      this.syncEditedData();
      console.log("Asset Prices:", this.assetPrices);
    },
    async getAssetPrice() {
      const response = await this.$axios.get(`/asset-prices?year=${this.year}`);
      this.assetPrices = response.data?.data?.asset_prices || [];
      this.syncEditedData();

      // Update legacy fields
      this.assetFields[0].model =
        response.data?.data?.asset_prices[0]?.land_price?.land_price || 0;
      this.assetFields[1].model =
        response.data?.data?.asset_prices[0]?.total_machine_price || 0;
      this.assetFields[2].model =
        response.data?.data?.asset_prices[0]?.total_building_price || 0;
      this.assetFields[3].model =
        response.data?.data?.asset_prices[0]?.total_infrastructure_price || 0;
      this.assetFields[4].model =
        response.data?.data?.asset_prices[0]?.total_intangible_asset_price || 0;
    },
    cleanEditedData(data) {
      delete data.land_price;
      [
        "konstruksi",
        "peralatan_tol",
        "supervisi",
        "desain_pendampingan",
        "overhead",
        "financial_cost",
        "idc",
      ].forEach((key) => {
        if (data[key]) delete data[key].total;
      });
      if (data.peralatan_tol) {
        delete data.peralatan_tol.infrastructure_price;
        delete data.peralatan_tol.intangible_asset_price;
      }
    },
    async submit() {
      this.isUploading = true;
      try {
        await this.$axios.post("/asset-prices", this.payload);
        this.dialog = false;
        this.isEditable = false;
        this.showNotification("Data updated successfully!", "success");
        await new Promise((resolve) => setTimeout(resolve, 2000));
        window.location.reload();
      } catch (error) {
        this.showNotification("Upload failed. Please try again.", "error");
      } finally {
        this.isUploading = false;
      }
    },
  },
};
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}

.scroll-to-current .v-list-item {
  max-height: 40px;
}

.scroll-to-current .v-list-item--active {
  background-color: #e0e0e0 !important;
}
</style>
